import { onAppearElement } from "@utils/domUtil";
import React, { useEffect, useRef } from "react";

import styles from "../Market/style.module.scss";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ product }) => {
  const forecastChart = useRef({});
  const symbols = product.acf.product_analysis_technical_overview_chart
  .split("\r\n")
  .find(item => item.includes("symbol"))
  .replace(`"symbol":`, "");
  const index = symbols.indexOf(":");
  const exchange = symbols.slice(0, index).replace(`"`, "").trim();
  const currency = symbols.slice(index + 1, symbols.length - 1).replace(`"`, "").trim();

  useEffect(() => {
    onAppearElement(
      () => {
        return document.getElementById(
          "forecastChart-tradingview-widget-container"
        );
      },
      () => {
        document.getElementById(
          "forecastChart-tradingview-widget-container"
        ).innerHTML = "";
        if (
          product.acf.product_analysis_forecast_chart !== null &&
          product.acf.product_analysis_forecast_chart !== ""
        ) {
          forecastChart.current = product.acf.product_analysis_forecast_chart
            .replace(/(\r\n|\n|\r)/gm, "")
            .replace(",}", "}");
          forecastChart.current = JSON.parse(forecastChart.current);
          forecastChart.current = {
            ...forecastChart.current,
            height: 386,
            locale: "vi_VN",
          };
          let scriptTag = document.createElement("script");
          scriptTag.async = true;
          scriptTag.type = "text/javascript";
          scriptTag.src =
            "https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js";
          scriptTag.text = JSON.stringify(forecastChart.current);

          // const divCopyright = document.createElement("div");
          // divCopyright.id = "tradingview-widget-copyright";
          // divCopyright.className = "tradingview-widget-copyright";
          // divCopyright.innerHTML = `<a href="https://www.tradingview.com/symbols/${exchange}-${currency}/technicals/" rel="noopener noreferrer" target="_blank"><span class="blue-text">Technical Analysis for ${currency}</span></a> by TradingView`;

          document
            .getElementById("forecastChart-tradingview-widget-container")
            .appendChild(scriptTag);
          // document
          //   .getElementById("forecastChart-tradingview-widget-container")
          //   .appendChild(divCopyright);
        } else {
          return;
        }
      }
    );
  }, [product]);

  return (
    <>
      <div className={styles["market-overview"]}>
        <div
          id="forecastChart-tradingview-widget-container"
          className={styles["tradingview-widget-container"]}
        >
          <script
            type="text/javascript"
            src="https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js"
            async
            dangerouslySetInnerHTML={{
              __html: `
                  ${JSON.stringify(forecastChart.current)}
                  `,
            }}
          ></script>
        </div>
      </div>
      
      <div 
        id='tradingview-widget-copyright' 
        className="tradingview-widget-copyright"
      >
        <a href={`https://www.tradingview.com/symbols/${exchange}-${currency}/technicals/`} rel="noopener noreferrer" target="_blank">
          <span className="blue-text">Technical Analysis for ${currency}</span>
        </a> by TradingView
      </div>
    </>
  );
};
